import { render, staticRenderFns } from "./ChnlCopyAssetDlg.vue?vue&type=template&id=9df865a0"
import script from "./ChnlCopyAssetDlg.vue?vue&type=script&lang=js"
export * from "./ChnlCopyAssetDlg.vue?vue&type=script&lang=js"
import style0 from "./ChnlCopyAssetDlg.vue?vue&type=style&index=0&id=9df865a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports